// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app";
// If you are using v7 or any earlier version of the JS SDK, you should import firebase using namespace import
// import * as firebase from "firebase/app"

// Add the Firebase products that you want to use
import "firebase/auth";
import "firebase/firestore";
import "firebase/database";

const firebaseConfig = {
    apiKey: "AIzaSyCS0qw58edO78bRsXeqcHfi3f0mVO9Hxrk",
    authDomain: "who2chat-matching.firebaseapp.com",
    projectId: "who2chat-matching",
    storageBucket: "who2chat-matching.appspot.com",
    messagingSenderId: "917448066989",
    appId: "1:917448066989:web:2e6fc018b0409f2fcd8324"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

function getData(entity_type, field_to_search, op=null, entityID=null) {
    return new Promise((resolve, reject) => {
        let newRef = firebase.firestore().collection(entity_type);

        if (op)
            newRef = newRef.where(field_to_search, op, entityID).get();
        else
            newRef = newRef.doc(field_to_search).get()

        if(newRef) {
            resolve(newRef);
        }
        else {
            reject("The write operation failed");
        }
    });
}

const copyCollection = async (old_name, new_name="") => {
    const target_name = new_name || (old_name+"_copy");

    const snapshot = await firestore.collection(old_name).get(); // load all the users in the system

    let newUsers = snapshot.docs
        .filter(doc => doc.data().name) // filter who set their name
        .filter(doc => doc.data().token)
        .map(doc => {
            return ({
                ...doc.data(), 
                id: doc.id,
            })
        });

    for(const user of newUsers) {
        await firestore.doc(`${target_name}/${user.id}`).set(user);
    }
}

/*
    Insert data at the given location
 */
function setData(data, entity_type, entityID) {
    firebase.firestore().collection(entity_type).doc(entityID).update(
       data
    , { merge: true })
    .catch((error) => {
        // The document probably doesn't exist.
        console.log(error); 
        alert("Error updating document: ", error);
    });
    
} 

export {copyCollection, getData, setData};

export default firebase;
export const firebase_instance = firebase;
export const firebase_auth = firebase.auth();
export const firestore = firebase.firestore();
export const firebase_database = firebase.database();
